import React from 'react';

function AuthLayout({ children }) {
  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay" />
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z" />
          </svg>
        </div>
      </div>

      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <span className="d-inline-block auth-logo">
                    <img src="/assets/images/logo-light.png" alt="Apply Heating" height="105" />
                  </span>
                </div>
                <p className="mt-3 fs-15 fw-medium">Protected access for the Apply Heating admin area.</p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
